import { TabValues } from '@/types/jetCatalog.types';
import styles from './tabs.module.scss';
import { motion } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/free-mode';

interface TabsProps {
  activeTab: TabValues;
  onTabChange: (tab: TabValues) => void;
}

const Tabs = ({ activeTab, onTabChange }: TabsProps) => {
  const tabButtons = Object.values(TabValues).map((tab) => (
    <motion.button
      key={tab}
      className={`${styles.jetCatalogButton} ${activeTab === tab ? styles.active : ''}`}
      onClick={() => onTabChange(tab)}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {tab}
    </motion.button>
  ));

  return <div className={styles.jetCatalogButtons}>{tabButtons}</div>;
};

export default Tabs;
